import type { ChangeEventHandler, InputHTMLAttributes } from 'react'

import { StyledCheckbox } from './Checkbox.styled'

export type CheckboxProps = {
  checked?: boolean
  indeterminate?: boolean
  disabled?: boolean
  id?: string
  label?: string
  dataTestId?: string
  error?: boolean
  /** id of the error / description text to link via `aria-describedby`. */
  ariaDescribedBy?: string
  onChange?: ChangeEventHandler<HTMLInputElement>
}

export const Checkbox = ({
  checked,
  indeterminate,
  disabled,
  id,
  label,
  dataTestId,
  error = false,
  ariaDescribedBy,
  onChange,
}: CheckboxProps) => {
  return (
    <StyledCheckbox
      className={error ? 'error' : ''}
      disableRipple
      checked={checked}
      indeterminate={indeterminate}
      disabled={disabled}
      id={id}
      color="default"
      onChange={onChange}
      slotProps={{
        input: {
          'aria-label': label,
          'data-testid': dataTestId,
          'aria-invalid': error || undefined,
          'aria-describedby': ariaDescribedBy,
        } as InputHTMLAttributes<HTMLInputElement>,
      }}
    />
  )
}
